(() => {
  const fit = (node) => {
    if (!node) return;
    node.style.removeProperty('font-size');
    node.style.whiteSpace = window.innerWidth <= 767 ? 'nowrap' : '';
    if (window.innerWidth > 767) return;
    let size = parseFloat(getComputedStyle(node).fontSize) || 36;
    const minimum = Number(node.dataset.caFitMinimum || 18);
    while (node.scrollWidth > node.clientWidth + 1 && size > minimum) {
      size -= .5;
      node.style.fontSize = `${size}px`;
    }
  };
  const run = () => document.querySelectorAll('[data-ca-fit-one-line]').forEach(fit);
  let timer;
  addEventListener('resize', () => { clearTimeout(timer); timer = setTimeout(run, 100); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
